'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Events = require('../Events');

var _getClass = require('./getClass');

var _getClass2 = _interopRequireDefault(_getClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApplyClassOnScroll = function (_React$Component) {
  (0, _inherits3.default)(ApplyClassOnScroll, _React$Component);

  function ApplyClassOnScroll(props, context) {
    (0, _classCallCheck3.default)(this, ApplyClassOnScroll);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ApplyClassOnScroll.__proto__ || (0, _getPrototypeOf2.default)(ApplyClassOnScroll)).call(this, props));

    _this.getChildContext = function () {
      return {
        applyClassGroupEmitter: _this.emitter
      };
    };

    _this.setClass = function () {
      var _this$props = _this.props,
          visible = _this$props.visible,
          offset = _this$props.offset,
          invisible = _this$props.invisible,
          once = _this$props.once;


      if (!_this.wrapperRef || once && _this.state.triggered) {
        return;
      }

      var rect = _this.wrapperRef.getBoundingClientRect();
      var elemTop = rect.top;
      var applyClassName = (0, _getClass2.default)(visible);

      var isVisible = elemTop + offset - global.window.innerHeight / 2 <= 0;

      if (isVisible) {
        _this.triggerGroup('visible');
        _this.setState({
          applyClassName: applyClassName,
          triggered: true
        });
      } else {
        _this.triggerGroup('invisible');
        _this.setState({
          applyClassName: (0, _getClass2.default)(invisible)
        });
      }
    };

    _this.handleScroll = function () {
      clearTimeout(_this.scrollTimeout);
      setTimeout(_this.setClass, 200);
    };

    _this.triggerGroup = function (eventType) {
      var triggerGroup = _this.props.triggerGroup;


      if (!triggerGroup || !_this.emitter) {
        return;
      }

      _this.emitter.emit(triggerGroup + '::' + eventType);
    };

    _this.state = {
      applyClassName: (0, _getClass2.default)(props.invisible),
      triggered: false
    };

    if (_this.props.triggerGroup) {
      _this.emitter = context.applyClassGroupEmitter || new _Events.Events();
    }
    return _this;
  }

  (0, _createClass3.default)(ApplyClassOnScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children;
      var applyClassName = this.state.applyClassName;

      return _react2.default.createElement(
        'div',
        {
          className: [className, applyClassName].filter(function (v) {
            return v;
          }).join(' '),
          ref: function ref(_ref) {
            _this2.wrapperRef = _ref;
          }
        },
        children
      );
    }
  }]);
  return ApplyClassOnScroll;
}(_react2.default.Component);

ApplyClassOnScroll.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  visible: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.object]),
  invisible: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.object]),
  offset: _propTypes2.default.number,
  once: _propTypes2.default.bool,
  triggerGroup: _propTypes2.default.string
};

ApplyClassOnScroll.defaultProps = {
  children: undefined,
  className: undefined,
  visible: undefined,
  invisible: undefined,
  offset: 0,
  once: false,
  triggerGroup: undefined
};

ApplyClassOnScroll.contextTypes = {
  applyClassGroupEmitter: _propTypes2.default.object
};

ApplyClassOnScroll.childContextTypes = {
  applyClassGroupEmitter: _propTypes2.default.object
};

exports.default = ApplyClassOnScroll;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/ApplyClass/ApplyClassOnScroll.js
// module id = 1076
// module chunks = 0